<template>
    <div class="Spinner">
      <div class="spinner"></div>
    </div>
  </template>
<script>
export default {
  data() {
    return {}
  }
}
</script>


 
<style scoped>
.spinner {
   width: 56px;
   height: 56px;
   display: grid;
   border: 4.5px solid #0000;
   border-radius: 50%;
   border-right-color: #3498db;
   animation: spinner-a4dj62 1s infinite linear;
}

.spinner::before,
.spinner::after {
   content: "";
   grid-area: 1/1;
   margin: 2.2px;
   border: inherit;
   border-radius: 50%;
   animation: spinner-a4dj62 2s infinite;
}

.spinner::after {
   margin: 8.9px;
   animation-duration: 3s;
}

@keyframes spinner-a4dj62 {
   100% {
      transform: rotate(1turn);
   }
}
.Spinner{

    display: flex;
    justify-content: center;

}
</style>